//importentity
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importentityApi  = createApi({
    reducerPath: "importentityApi",
    baseQuery,
    tagTypes: ["importentity"],
    endpoints: (builder) => ({
      
    createEntity: builder.mutation({
        query: ({ id, ...data }) => ({
          url: `import/entity/${id}`,
          method: "PUT", // API requires PUT
          headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
          body: { entity: data }, 
        }),
        invalidatesTags: ["importentity"],
      }),
      updateEntity: builder.mutation({
        query: ({ id, subId, ...data }) => ({
          url: `import/entity/${id}/${subId}`,
          method: "PUT",
          headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
          body: { entity: data }, 
  
        }),
        invalidatesTags: ["importentity"],
    
      }),
      deleteEntity: builder.mutation({
        query: ({ id }) => ({
          url: `import/entity/${id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["importentity"],
      }),

      getEntityId: builder.query({
        query: ({id}) => `import/entity/${id}`,
        transformResponse: (response) => 
          {
            const data= response?.data ?? [];
            const normalized = Array.isArray(data) ? data : [data];
            return normalized.map((item,index) => ({
              ...item,
              SrNo:index+1,
              id: item.importEntityId, // 👈 use backend's exportEntityId
            }));

          },
        providesTags: ["importentity"],
      }), 


    })
});
export const {
    useCreateEntityMutation,
    useUpdateEntityMutation,
    useDeleteEntityMutation,
    useLazyGetEntityIdQuery,

   
  } = importentityApi;